import universal from 'react-universal-component';

export default universal(() => import('./ResetPassword'));


// WEBPACK FOOTER //
// ./src/app/views/PasswordReset/index.js